var _style, _g, _path, _path2, _path3, _defs, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46.8 46.8",
    style: {
      enableBackground: "new 0 0 46.8 46.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF6363;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.4;}\n\t.st2{clip-path:url(#SVGID_00000008858556096744149240000005763790826333638320_);}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,0.9h25c5.5,0,10,4.5,10,10v25c0,5.5-4.5,10-10,10h-25c-5.5,0-10-4.5-10-10v-25C0.9,5.4,5.4,0.9,10.9,0.9 z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.2,26.2c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c3.9,0,4.1,0.1,6.5,1.3c0.5,0.2,1,0.5,1.5,0.8l0,0 c0.1,0,0.1,0,0.2,0h4.9c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2,0,0.3-0.1,0.5c-0.1,0.1-0.2,0.2-0.4,0.3H22 c0,0-0.1,0-0.1,0c-0.2,0-1.6,0.3-1.7,1.6c0,0.3,0.2,0.5,0.4,0.5c0.3,0,0.5-0.2,0.5-0.4c0.1-0.6,0.7-0.7,0.9-0.8h5.7 c0.1,0,0.1,0,0.2,0l-0.2-0.4l0.2,0.4c0.4-0.2,0.7-0.4,0.9-0.8c0.2-0.3,0.3-0.7,0.2-1c0-0.3-0.1-0.7-0.4-1c-0.2-0.3-0.6-0.6-1-0.7 c-0.1,0-0.1,0-0.2,0h-4.9c-0.6-0.3-1-0.5-1.4-0.7C18.6,26.3,18.3,26.2,14.2,26.2L14.2,26.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.2,33.8c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h2.1c8.8,3.2,9.7,2.6,14.8-0.5c1.5-0.9,3.4-2.1,6-3.4 L37,30.4l0.2,0.4c0,0,0.1-0.1,0.1-0.1c0.5-0.5,0.7-1.1,0.7-1.6c0-0.3-0.1-0.7-0.3-0.9c-0.2-0.3-0.4-0.5-0.7-0.7 c-0.4-0.2-0.9-0.3-1.5-0.1l0.2,0.4l-0.2-0.4c0,0,0,0-0.1,0l-8.1,3.5c-0.2,0.1-0.4,0.4-0.2,0.6c0.1,0.2,0.4,0.4,0.6,0.2l8.1-3.5 c0,0,0,0,0,0l0,0c0.2-0.1,0.5-0.1,0.7,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.3,0.1,0.5c0,0.3-0.1,0.6-0.4,0.9 c-2.6,1.3-4.5,2.5-6,3.4c-4.8,2.9-5.6,3.4-14.1,0.4c-0.1,0-0.1,0-0.2,0L14.2,33.8L14.2,33.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.6,25.4v10.2c0,0.3-0.2,0.5-0.5,0.5h-4c-0.3,0-0.5-0.2-0.5-0.5V25.4c0-0.3,0.2-0.5,0.5-0.5h4 C14.4,24.9,14.6,25.1,14.6,25.4z M13.7,35.1v-9.2h-3.1v9.2H13.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 21.6,
    y: 10.9,
    width: 10,
    height: 10
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149344189783883660430000015793561630530540677_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000149344189783883660430000015793561630530540677_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.5,15.9l3.9-3.9c0.3-0.3,0.3-0.7,0-0.9c-0.3-0.3-0.7-0.3-0.9,0L26.6,15l-3.9-3.9c-0.3-0.3-0.7-0.3-0.9,0 c-0.3,0.3-0.3,0.7,0,0.9l3.9,3.9l-3.9,3.9c-0.3,0.3-0.3,0.7,0,0.9c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2l3.9-3.9l3.9,3.9 c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2c0.3-0.3,0.3-0.7,0-0.9L27.5,15.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/payment_failed.a47b8187f4cf1dabf2e038b8fdc79c28.svg";
export { ForwardRef as ReactComponent };